export default __webpack_public_path__ + "static/media/wx.2618f55b.jpg";